import { createContext, useContext, useState, type ReactNode } from 'react'

interface UiFlags {
  showTrace: boolean
  setShowTrace: (val: boolean) => void
}

const UiFlagsContext = createContext<UiFlags | undefined>(undefined)

export function UiFlagsProvider({ children }: { children: ReactNode }) {
  const [showTrace, setShowTrace] = useState<boolean>(import.meta.env.DEV)
  return (
    <UiFlagsContext.Provider value={{ showTrace, setShowTrace }}>
      {children}
    </UiFlagsContext.Provider>
  )
}

export function useUiFlags() {
  const ctx = useContext(UiFlagsContext)
  if (!ctx) throw new Error('useUiFlags must be used within UiFlagsProvider')
  return ctx
}
